import React, {
  forwardRef,
  Fragment,
  useEffect,
  useRef,
  useState,
} from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import styles from "./MdaReq.module.css";
import { getMDAList } from "../../apis/mdaApi";


const DropdownList = forwardRef(
  (
    { isVisible = false, data, onClick, handleClose, container, setValue },
    ref
  ) => {
    const [options, setOptions] = useState(data);

    const handleSearch = (val) => {
      const $options = [...data];
      if (val.length > 0) {
        const searchResult = $options.filter((item) =>
          typeof item === "object"
            ? item.companyName.toLowerCase().includes(val.toLowerCase())
            : item.toLowerCase().includes(val.toLowerCase())
        );
        setOptions(searchResult);
      } else {
        setOptions(data);
      }
    };

    const handleClick = (option) => {
      onClick(option);
      setOptions(data);
      handleClose();
      setValue(option.companyName);
    };

    const globalListner = (e) => {
      if (
        container &&
        container.current &&
        container.current.contains(e.target)
      ) {
        return;
      }
      handleClose();
    };

    useEffect(() => {
      setOptions(data);
    }, [data]);

    useEffect(() => {
      document.addEventListener("click", globalListner);
      return () => {
        document.removeEventListener("click", globalListner);
      };
    }, []);

    if (!isVisible) return <></>;

    return (
      <div className={styles.dropdownList} ref={ref}>
        <input
          className={`${styles.input} ${styles.dropdownListInput}`}
          type="text"
          placeholder="Search list"
          onChange={(e) => handleSearch(e.target.value)}
        />
        <div className={styles.dropdownListItemContainer}>
          {options &&
            options.length > 0 &&
            options.map((option, index) => (
              <Fragment key={`${option}-${index}`}>
                <button
                  className={styles.dropdownListItem}
                  type="button"
                  onClick={() => handleClick(option)}
                >
                  {option.companyName}
                </button>
              </Fragment>
            ))}
        </div>
      </div>
    );
  }
);

export default function MdaRequest() {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState("Select MDA");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedOption, setSelectedOption] = useState(null);
  const [laoding, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [tenantCategory, setTenantCategory] = useState(
    searchParams.get("tenantCategory")
  );
  const [email, setEmail] = useState(
    searchParams.get("email")
  );
  const [accessToken, setAccessToken] = useState(
    searchParams.get("accessToken")
  );
  // Get tenantId from subdomain. this represent the mda requesting
  const [tenantId, setTenantId] = useState(() => {
    // Parse the hostname to get the subdomain
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    // The first part is the subdomain (tenantId)
    return parts.length > 2 ? parts[0] : null;
  });

  const [MDAList, setMDAList] = useState([]);

  const inputRef = useRef();
  const dropdownRef = useRef();

  const navigate = useNavigate();
  const handleProceed = () => {
    navigate("/mda", {
      state: { param: selectedOption, param1: MDAList, param2: email, accessToken, mda:tenantId},
    });
  };
 const fetchMDA = async () => {
   setLoading(true);
   const result = await getMDAList({ tenantCategory });
   if (result.ok) {
     const sortedMDAList = result.data.merchants.sort((a, b) =>
       a.companyName.localeCompare(b.companyName)
     );
     setMDAList(sortedMDAList);
   } else {
     console.log(result.originalError.message);
   }
   setLoading(false);
 };
  useEffect(() => {
    fetchMDA();
  }, [tenantCategory]);


  return (
    <div className={styles.wrapper}>

    <div className={styles.container}>
      <div className={styles.bodyContainer}>
        <div className={styles.mdaRow}>
          <div>
            <h1 className={styles.mdaTitle}>Inter MDA Request</h1>{" "}
          </div>
          {/* <div className={styles.icon2}>
            {" "}
            <img
              src=" https://res.cloudinary.com/dso7hgghd/image/upload/v1705918372/info_fw4ton.svg"
              width={26}
              alt=""
            />
          </div> */}
        </div>
        <p className={styles.subtext}>
          {" "}
          Select MDA to make request, track and engage on your task{" "}
        </p>
        <div>
          <div
            className={`${styles.inputContainer} ${styles.dropdownContainer}`}
          >
            <label className={styles.label}>
              {laoding && <small>Loading...</small>}
            </label>
            <div ref={inputRef}>
              <input
                type="text"
                className={styles.input}
                placeholder={`Select MDA`}
                value={value}
                onClick={() => setIsVisible(true)}
              />
              <span className={styles.caretIcon}>
                <img
                  src=" https://res.cloudinary.com/dso7hgghd/image/upload/v1706419397/Icon_ionic-md-arrow-dropdown_zngpf1.png"
                  width={10}
                  alt=""
                />
              </span>

              <DropdownList
                ref={dropdownRef}
                isVisible={isVisible}
                handleClose={() => setIsVisible(false)}
                container={inputRef}
                data={MDAList}
                onClick={(option) => {
                  setValue(option.companyName);
                  setSelectedOption(option);
                }}
                setValue={setValue} // Pass setValue as a prop
              />
            </div>
          </div>
          <div className={styles.buttonContainer}>
            <button
              className={`${styles.proceedBtn} ${
                selectedOption === null ? styles.disabledCursor : ""
              }`}
              onClick={handleProceed}
              disabled={selectedOption === null}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
    <div className={styles.sidebar}>
    {/* Add your text or any other content for the sidebar */}
    <img
            src="https://res.cloudinary.com/dso7hgghd/image/upload/v1708082882/Easy_Guide_-_Track_Ticket_udlaaf.svg"
            alt="Guide"
          />
  </div>
  </div>
  );
}
